__turbopack_context__.v({
  "buttonClass": "Button-module__e7WGRa__buttonClass",
  "learn-more": "Button-module__e7WGRa__learn-more",
  "newOne": "Button-module__e7WGRa__newOne",
  "newsLettetPb": "Button-module__e7WGRa__newsLettetPb",
  "plusFont": "Button-module__e7WGRa__plusFont",
  "promoButton": "Button-module__e7WGRa__promoButton",
  "smallButton": "Button-module__e7WGRa__smallButton",
  "sub-button": "Button-module__e7WGRa__sub-button",
  "submit-button": "Button-module__e7WGRa__submit-button",
  "unsubscribe-btn": "Button-module__e7WGRa__unsubscribe-btn",
});
